import { render, staticRenderFns } from "./login-failed-count-dialog.vue?vue&type=template&id=6970b0a6&scoped=true&"
import script from "./login-failed-count-dialog.vue?vue&type=script&lang=js&"
export * from "./login-failed-count-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6970b0a6",
  null
  
)

export default component.exports